import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectDbnpListItems } from '../../../../redux/dbnp/selector';
import storePersist from '../../../../redux/storePersist';
import { selectGlobalDbnTaxonomyDomainsListItems } from '../../../../redux/global-dbn-taxonomy-domains/selector';
import { dbnp } from '../../../../redux/dbnp/action';
import { globalDbnTaxonomyDomains } from '../../../../redux/global-dbn-taxonomy-domains/action';
import PageLoader from '../../../../components/PageLoader';
import GlobalDBNPRegistriesComponent from '../components/global-dbnp-registries.component';
import { globalDBNPRegistrations } from '../../../../redux/global-dbnp-registrations/action';
import { selectGlobalDBNPRegistrationsQueryItems } from '../../../../redux/global-dbnp-registrations/selector';


const GlobalDBNPRegistration = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const dbnpRegistriesQuery = useSelector(selectGlobalDBNPRegistrationsQueryItems)
    const dpnpNameLists = useSelector(selectDbnpListItems)
    const globalDbnTaxonomyDomainNameLists = useSelector(selectGlobalDbnTaxonomyDomainsListItems)
    const librariesItems = storePersist?.get("library")?.current;
    const countries =  storePersist.get('countries').current?.items;
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ selectedDbnpRegistry, setSelectedDbnpRegistry ] = useState<any>({})

    const fetchDbnpRegistryById = () => {
        dispatch(globalDBNPRegistrations.query({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations/query`, 
            entity: 'globalOrgRegistrations', 
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedDbnpRegistry({ ...selectedDbnpRegistry, [fields[0]]: value });
    }

    useEffect(
        () => {
            dispatch(dbnp.list({ 
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`, 
                entity: 'dbnp', 
                jsonData: {} 
            })).then(() => {
                dispatch(globalDbnTaxonomyDomains.list({ 
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, 
                    entity: 'opennetworkDomains', 
                    jsonData: {"Context": {},
        "Records": [
            {
                "IsSubDomain": null //to get all records 
            }
        ],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 100,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
        }} 
                }))
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchDbnpRegistryById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        },
        []
    )

    const parentDomain = globalDbnTaxonomyDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === false
    )
    const subDomains = globalDbnTaxonomyDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === true
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedDbnpRegistry(dbnpRegistriesQuery?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(globalDBNPRegistrations.resetAction({ actionType: 'update' }))
            await dispatch(globalDBNPRegistrations.update({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations`, 
                entity: 'globalOrgRegistrations', 
                jsonData: {
                    Records: [
                        selectedDbnpRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(globalDBNPRegistrations.resetAction({ actionType: 'create' }))
            await dispatch(globalDBNPRegistrations.create({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-registrations`, 
                entity: 'globalOrgRegistrations', 
                jsonData: {
                    Records: [
                        selectedDbnpRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/dbn/global-dbnp-registrations')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <GlobalDBNPRegistriesComponent
                    handleInnerFormChange={handleInnerFormChange}
                    handleBacicInnerFormChange={handleBacicInnerFormChange}
                    selectedDbnpRegistry={selectedDbnpRegistry}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    dbnpname={dpnpNameLists?.result?.items}
                    opsnumber={librariesItems?.Ops_no}
                    domains={parentDomain}
                    subDomains={subDomains}
                    countries={countries}
                />
            }
        </>
    )

}

export default GlobalDBNPRegistration;